export default __webpack_public_path__ + "static/media/gw.06ee35c4.svg";